/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_Ogtitle1Inputs */

const ja_contact_meta_ogtitle1 = /** @type {(inputs: Contact_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN（株式会社プレイブレーン） | お問い合わせ`)
};

const en_contact_meta_ogtitle1 = /** @type {(inputs: Contact_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Contact Us`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Contact Us" |
*
* @param {Contact_Meta_Ogtitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_meta_ogtitle1 = /** @type {((inputs?: Contact_Meta_Ogtitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_Ogtitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_meta_ogtitle1(inputs)
	return en_contact_meta_ogtitle1(inputs)
});
export { contact_meta_ogtitle1 as "contact_meta_ogTitle" }